import i18next from 'i18next';

i18next.addResources('es_CL', 'CarouselTemplate', {
  labelAltBannerImage: 'Banner promocional'
});

i18next.addResources('pt_PT', 'CarouselTemplate', {
  labelAltBannerImage: 'Bandeira promocional'
});
